function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-168.000000, -516.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(168.000000, 516.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F0F5F6",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Credit-card",
  transform: "translate(12.000000, 13.000000)",
  fillRule: "nonzero",
  stroke: "#C9D6DB",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "14 2.4375 5.6 10.5625 2 7.515625"
})))));

var SvgCheckRound = function SvgCheckRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-round.0b45a90e.svg";
export { ForwardRef as ReactComponent };